<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 13H1"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3943 4.31906C18.7421 4.52741 19.0229 4.82535 19.205 5.17939L23 12.5V18.875C23 19.4386 22.7682 19.9791 22.3556 20.3776C21.9431 20.7761 21.3835 21 20.8 21H3.2C2.61652 21 2.05695 20.7761 1.64437 20.3776C1.23178 19.9791 1 19.4386 1 18.875V12.5L4.795 5.17939C4.97713 4.82535 5.25791 4.52741 5.60575 4.31906"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 1L12 8"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 6L12 9L9 6"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>